<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="studiesForm">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="institucion"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Institución o escuela <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionInicio"
                maxlength="4"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de inicio <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionFin"
                maxlength="4"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de finalización <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="estatusEstudios"
                item-value="id"
                item-text="title"
                v-model="estatusEstudiosElegido"
                :rules="required"
              >
                <template v-slot:label>Estatus de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="tipoEstudios"
                item-value="id"
                item-text="title"
                v-model="tipoEstudioElegido"
                :rules="required"
              >
                <template v-slot:label>Tipo de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="comprobanteEstudios"
                item-value="id"
                item-text="title"
                v-model="comprobanteEstudioElegido"
                :rules="required"
              >
                <template v-slot:label> Tipo de comprobante de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                no-resize
                rows="4"
                color="secondary"
                background-color="primary"
                label="Observaciones (Opcional)"
                v-model="observaciones"
                rounded
                filled
                dense
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        color="secondary"
        class="primary--text px-8"
        :disabled="!studiesForm || loading"
        :loading="loading"
        @click="triggerSaveStudies()"
      >
        Registrar estudios
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      studiesForm: false,
      loading: false,
      institucion: '',
      generacionInicio: '',
      generacionFin: '',
      observaciones: '',
      comprobanteEstudioElegido: null,
      tipoEstudioElegido: null,
      estatusEstudiosElegido: null,
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  async mounted() {
    await this.fetchComprobantesEstudios()
    await this.fetchEstatusEstudios()
    await this.fetchTipoEstudios()
  },

  computed: {
    ...mapGetters('comprobanteEstudios', {
      comprobanteEstudios: 'getComprobantesEstudios',
    }),
    ...mapGetters('estatusEstudios', {
      estatusEstudios: 'getEstatusEstudios',
    }),
    ...mapGetters('estudio', {
      tipoEstudios: 'getTipoEstudios',
    }),
  },

  methods: {
    ...mapActions('estudio', ['saveEstudiosPersonal', 'fetchEstudiosByPersonal', 'fetchTipoEstudios']),
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),

    async triggerSaveStudies() {
      this.loading = true

      await this.saveEstudiosPersonal({
        fk_idPersonal: this.id,
        institucion: this.institucion,
        generacion: this.generacionInicio + '-' + this.generacionFin,
        observaciones: this.observaciones,
        fk_idCatEstatusEstudio: this.estatusEstudiosElegido,
        fk_idCatEstudio: this.tipoEstudioElegido,
        fk_idComprobanteEstudio: this.comprobanteEstudioElegido,
      })

      await this.fetchEstudiosByPersonal(this.id)
      this.loading = false
      this.$emit('close')
      this.closeDialog()
    },

    closeDialog() {
      this.institucion = ''
      this.generacionInicio = ''
      this.generacionFin = ''
      this.observaciones = ''
      this.comprobanteEstudioElegido = null
      this.tipoEstudioElegido = null
      this.estatusEstudiosElegido = null
      this.loading = false
      this.$refs.form.resetValidation()
    },
  },
}
</script>
